import { resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
import { defineComponent, onMounted, onBeforeUnmount, watch, reactive } from "vue";
import { useRoute } from "vue-router";
import _ from "lodash";
import "@vant/touch-emulator";
// components
import MGlobalFooter from "@/components/m/common/footer.vue";
import MHeaderBox from "@/components/m/common/header.vue";
import MNavBar from "@/components/m/common/navbar.vue";
// pc
import GlobalFooterPC from "@/components/pc/common/footer-PC.vue";
import PcBanner from "@/components/pc/common/banner.vue";
import SideCode from "@/components/pc/common/side-code.vue";
import InfoAnchorBox from "@/components/pc/common/anchor-box.vue";
import AnchorBoxHome from "@/components/pc/common/anchor-box-home.vue";
import PcMNavBar from "@/components/pc/common/nav-bar.vue";
// import AnchorBox from "@/pages/homePage/pc/components/anchor-box.vue";
// api

export default defineComponent({
  setup() {
    const route = useRoute();
    onMounted(() => {
      window.addEventListener("resize", resizeHandlerFct);
    });
    onBeforeUnmount(() => {
      window.removeEventListener("resize", resizeHandlerFct);
    });
    const appState = reactive({
      routePath: route.path,
      haveBannerList: ["/"],
      isMobbile: window.screen.width < 1200
    });
    watch(() => route.path, path => {
      appState.routePath = path;
    });
    watch(() => appState.isMobbile, () => {
      //窗口宽度发生质变就刷新
      setInterval(function () {
        location.reload();
      }, 1000);
    });
    function resizeHandlerFct() {
      appState.isMobbile = document.body.clientWidth < 1200;
    }
    return () => _createVNode("div", {
      "class": appState.isMobbile ? "mobile-container container" : "pc-container container",
      "id": "container-id"
    }, [appState.isMobbile ? "" : _createVNode(PcMNavBar, null, null), appState.isMobbile ? _createVNode("div", {
      "class": "inner-box"
    }, [_createVNode(MHeaderBox, {
      "isBanner": _.includes(appState.haveBannerList, appState.routePath)
    }, null), _createVNode(MNavBar, null, null), _createVNode(_resolveComponent("router-view"), null, null), _createVNode(MGlobalFooter, null, null)]) : _createVNode("div", {
      "class": "inner-box"
    }, [_.includes(appState.haveBannerList, appState.routePath) ? _createVNode(PcBanner, null, null) : "", _createVNode(_resolveComponent("router-view"), null, null), _createVNode(GlobalFooterPC, null, null), _createVNode(SideCode, null, null)]), !appState.isMobbile && appState.routePath === "/race-info" ? _createVNode(InfoAnchorBox, null, null) : "", !appState.isMobbile && appState.routePath === "/" ? _createVNode(AnchorBoxHome, null, null) : ""]);
  }
});